/* eslint-disable */
/* tslint:disable */

/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface CommentItem {
    /** 评论id */
    comment_id?: string;

    /** 文章在评论系统的id */
    article_id?: string;

    /** 专题在评论系统的id */
    special_id?: string;

    /** 用户名 */
    uname?: string;

    /** 用户id */
    user_id?: string;

    /** uuid */
    uuid?: string;

    /** 客户端ip */
    client_ip?: string;

    /** 根据ip查看的来源 */
    ip_from?: string;

    /** 评论创建时候 */
    create_time?: string;

    /** 评论最后更新 */
    last_modtime?: string;

    /** 评论内容 */
    comment_contents?: string;

    /** 引用id */
    quote_id?: string;

    /** 根id */
    main_id?: string;

    /** 来源 */
    from?: string;

    /** 临时id */
    comment_temid?: string;

    /** 点赞数（前端展示请使用uptimes） */
    integral?: string;

    /** 扩展参数，透传 */
    ext2?: string;

    /** 用户评论地址 */
    user_url?: string;

    /** 格式化之后的日期 */
    comment_date?: string;

    /** 子评论, 其中包含数量和列表 */
    children?: { count: number; comments: CommentItem[] };

    /** 头像地址 */
    faceurl?: string;

    /** 用户角色 */
    user_role?: string[];

    /** 文档名称 */
    doc_name?: string;

    /** 文档id */
    doc_url?: string;

    /** 文档可访问的地址 */
    permalink?: string;

    /** 文档创建时间 */
    add_time?: string;

    /** 点赞数 */
    uptimes?: number;

    /** 图片列表 */
    pics?: string[];

    /** 是否为精华 1 是 0否 */
    essences?: string;

    /** 用户标签 */
    user_label?: string[];
}

export interface Page {
    /** 评论数 */
    count?: number;

    /** 参与数 */
    join_count?: number;

    /** 评论列表 */
    comments?: object[];

    /** 是否允许评论，1表示允许, 0为锁定评论，-1关闭评论 */
    allow_comment?: number;
}

export type QueryParamsType = Record<string | number, any>;
export type ResponseFormat = keyof Omit<Body, 'body' | 'bodyUsed'>;

export interface FullRequestParams extends Omit<RequestInit, 'body'> {
    /** set parameter to `true` for call `securityWorker` for this request */
    secure?: boolean;
    /** request path */
    path: string;
    /** content type of request body */
    type?: ContentType;
    /** query params */
    query?: QueryParamsType;
    /** format of response (i.e. response.json() -> format: "json") */
    format?: ResponseFormat;
    /** request body */
    body?: unknown;
    /** base url */
    baseUrl?: string;
    /** request cancellation token */
    cancelToken?: CancelToken;
}

export type RequestParams = Omit<FullRequestParams, 'body' | 'method' | 'query' | 'path'>;

export interface ApiConfig<SecurityDataType = unknown> {
    baseUrl?: string;
    baseApiParams?: Omit<RequestParams, 'baseUrl' | 'cancelToken' | 'signal'>;
    securityWorker?: (securityData: SecurityDataType | null) => Promise<RequestParams | void> | RequestParams | void;
    customFetch?: typeof fetch;
}

export interface HttpResponse<D extends unknown, E extends unknown = unknown> extends Response {
    data: D;
    error: E;
}

type CancelToken = Symbol | string | number;

export enum ContentType {
    Json = 'application/json',
    FormData = 'multipart/form-data',
    UrlEncoded = 'application/x-www-form-urlencoded',
}

export class HttpClient<SecurityDataType = unknown> {
    public baseUrl: string = '';
    private securityData: SecurityDataType | null = null;
    private securityWorker?: ApiConfig<SecurityDataType>['securityWorker'];
    private abortControllers = new Map<CancelToken, AbortController>();
    private customFetch = (...fetchParams: Parameters<typeof fetch>) => fetch(...fetchParams);

    private baseApiParams: RequestParams = {
        credentials: 'same-origin',
        headers: {},
        redirect: 'follow',
        referrerPolicy: 'no-referrer',
    };

    constructor(apiConfig: ApiConfig<SecurityDataType> = {}) {
        Object.assign(this, apiConfig);
    }

    public setSecurityData = (data: SecurityDataType | null) => {
        this.securityData = data;
    };

    protected encodeQueryParam(key: string, value: any) {
        const encodedKey = encodeURIComponent(key);
        return `${encodedKey}=${encodeURIComponent(typeof value === 'number' ? value : `${value}`)}`;
    }

    protected addQueryParam(query: QueryParamsType, key: string) {
        return this.encodeQueryParam(key, query[key]);
    }

    protected addArrayQueryParam(query: QueryParamsType, key: string) {
        const value = query[key];
        return value.map((v: any) => this.encodeQueryParam(key, v)).join('&');
    }

    protected toQueryString(rawQuery?: QueryParamsType): string {
        const query = rawQuery || {};
        const keys = Object.keys(query).filter((key) => 'undefined' !== typeof query[key]);
        return keys
            .map((key) =>
                Array.isArray(query[key]) ? this.addArrayQueryParam(query, key) : this.addQueryParam(query, key),
            )
            .join('&');
    }

    protected addQueryParams(rawQuery?: QueryParamsType): string {
        const queryString = this.toQueryString(rawQuery);
        return queryString ? `?${queryString}` : '';
    }

    private contentFormatters: Record<ContentType, (input: any) => any> = {
        [ContentType.Json]: (input: any) =>
            input !== null && (typeof input === 'object' || typeof input === 'string') ? JSON.stringify(input) : input,
        [ContentType.FormData]: (input: any) =>
            Object.keys(input || {}).reduce((formData, key) => {
                const property = input[key];
                formData.append(
                    key,
                    property instanceof Blob
                        ? property
                        : typeof property === 'object' && property !== null
                        ? JSON.stringify(property)
                        : `${property}`,
                );
                return formData;
            }, new FormData()),
        [ContentType.UrlEncoded]: (input: any) => this.toQueryString(input),
    };

    protected mergeRequestParams(params1: RequestParams, params2?: RequestParams): RequestParams {
        return {
            ...this.baseApiParams,
            ...params1,
            ...(params2 || {}),
            headers: {
                ...(this.baseApiParams.headers || {}),
                ...(params1.headers || {}),
                ...((params2 && params2.headers) || {}),
            },
        };
    }

    protected createAbortSignal = (cancelToken: CancelToken): AbortSignal | undefined => {
        if (this.abortControllers.has(cancelToken)) {
            const abortController = this.abortControllers.get(cancelToken);
            if (abortController) {
                return abortController.signal;
            }
            return void 0;
        }

        const abortController = new AbortController();
        this.abortControllers.set(cancelToken, abortController);
        return abortController.signal;
    };

    public abortRequest = (cancelToken: CancelToken) => {
        const abortController = this.abortControllers.get(cancelToken);

        if (abortController) {
            abortController.abort();
            this.abortControllers.delete(cancelToken);
        }
    };

    public request = async <T = any, E = any>({
        body,
        secure,
        path,
        type,
        query,
        format,
        baseUrl,
        cancelToken,
        ...params
    }: FullRequestParams): Promise<HttpResponse<T, E>> => {
        const secureParams =
            ((typeof secure === 'boolean' ? secure : this.baseApiParams.secure) &&
                this.securityWorker &&
                (await this.securityWorker(this.securityData))) ||
            {};
        const requestParams = this.mergeRequestParams(params, secureParams);
        const queryString = query && this.toQueryString(query);
        const payloadFormatter = this.contentFormatters[type || ContentType.Json];
        const responseFormat = format || requestParams.format;

        return this.customFetch(`${baseUrl || this.baseUrl || ''}${path}${queryString ? `?${queryString}` : ''}`, {
            ...requestParams,
            headers: {
                ...(type && type !== ContentType.FormData ? { 'Content-Type': type } : {}),
                ...(requestParams.headers || {}),
            },
            signal: cancelToken ? this.createAbortSignal(cancelToken) : requestParams.signal,
            body: typeof body === 'undefined' || body === null ? null : payloadFormatter(body),
        }).then(async (response) => {
            const r = response as HttpResponse<T, E>;
            r.data = null as unknown as T;
            r.error = null as unknown as E;

            const data = !responseFormat
                ? r
                : await response[responseFormat]()
                      .then((data) => {
                          if (r.ok) {
                              r.data = data;
                          } else {
                              r.error = data;
                          }
                          return r;
                      })
                      .catch((e) => {
                          r.error = e;
                          return r;
                      });

            if (cancelToken) {
                this.abortControllers.delete(cancelToken);
            }

            if (!response.ok) throw data;
            return data;
        });
    };
}

/**
 * @title comment
 * @version 1.0.0
 */
export class Api<SecurityDataType extends unknown> extends HttpClient<SecurityDataType> {
    v3 = {
        /**
         * @description 原文档地址：http://doc.staff.ifeng.com/apidoc/comment/#api-01_Comment-GetCommentsV3
         *
         * @name GetCommentsList
         * @summary v3版本获取评论列表
         * @request GET:/v3/get/comments
         */
        getCommentsList: (
            query: {
                doc_url: string;
                p: number;
                pagesize?: number;
                pagestart?: number;
                orderby?: string;
                order?: string;
                first_cmt_id?: number;
                format?: string;
                callback?: string;
            },
            params: RequestParams = {},
        ) =>
            this.request<
                {
                    count?: number;
                    join_count?: number;
                    comments?: {
                        comment_id?: string;
                        article_id?: string;
                        special_id?: string;
                        uname?: string;
                        user_id?: string;
                        uuid?: string;
                        client_ip?: string;
                        ip_from?: string;
                        create_time?: string;
                        last_modtime?: string;
                        comment_contents?: string;
                        quote_id?: string;
                        main_id?: string;
                        from?: string;
                        comment_temid?: string;
                        integral?: string;
                        ext2?: string;
                        user_url?: string;
                        comment_date?: string;
                        children?: { count: number; comments: CommentItem[] };
                        faceurl?: string;
                        user_role?: string[];
                        doc_name?: string;
                        doc_url?: string;
                        permalink?: string;
                        add_time?: string;
                        uptimes?: number;
                        pics?: string[];
                        essences?: string;
                        user_label?: string[];
                    }[];
                    allow_comment?: number;
                },
                any
            >({
                path: `/v3/get/comments`,
                method: 'GET',
                query: query,
                format: 'json',
                ...params,
            }),

        /**
         * @description 原文档地址：http://doc.staff.ifeng.com/apidoc/comment/#api-01_Comment-GetChildren
         *
         * @name GetChildrenList
         * @summary 获取子评论列表
         * @request GET:/v3/get/children
         */
        getChildrenList: (
            query: {
                doc_url: string;
                comment_id: string;
                p?: number;
                pagesize?: number;
                pagestart?: number;
                order?: string;
                format?: string;
                callback?: string;
            },
            params: RequestParams = {},
        ) =>
            this.request<{ count?: number; join_count?: number; comments?: CommentItem; allow_comment?: number }, any>({
                path: `/v3/get/children`,
                method: 'GET',
                query: query,
                format: 'json',
                ...params,
            }),
    };
}
